import { valibotResolver } from '@hookform/resolvers/valibot';
import { nonEmpty, nonNullable, nullable, number, object, pipe, string, trim } from 'valibot';

import type { IAssetTracking } from '@model/assetTracking';
import type { IGPSTracker } from '@model/gpsTracker';

export const ASSET_TRACKING_FIELDS = {
  ASSET_TAG: 'assetTag',
  EXTERNAL_ASSET_ID: 'externalAssetId',
  GPS_TRACKER_ID: 'gpsTrackerId',
};

export interface IFormAssetTracking {
  assetTag: string;
  externalAssetId: string;
  gpsTrackerId: { id: string | number; fullName?: string };
}

export const schemaAssetTracking = valibotResolver(
  object({
    [ASSET_TRACKING_FIELDS.ASSET_TAG]: pipe(
      string('This field is required.'),
      trim(),
      nonEmpty('This field is required.'),
    ),
    [ASSET_TRACKING_FIELDS.EXTERNAL_ASSET_ID]: pipe(
      string('This field is required.'),
      trim(),
      nonEmpty('This field is required.'),
    ),
    [ASSET_TRACKING_FIELDS.GPS_TRACKER_ID]: object({
      id: nonNullable(nullable(number()), 'This field is required.'),
      fullName: string(),
    }),
  }),
);

export const assetTrackingValues = (asset: IAssetTracking, gpsTracker: IGPSTracker) => {
  return {
    [ASSET_TRACKING_FIELDS.ASSET_TAG]: asset?.assetTag || '',
    [ASSET_TRACKING_FIELDS.EXTERNAL_ASSET_ID]: asset?.externalAssetId || '',
    [ASSET_TRACKING_FIELDS.GPS_TRACKER_ID]: gpsTracker?.id ? gpsTracker : { id: null },
  };
};
